<template>
  <div>
    <request>

    </request>
  </div>
</template>
<script>
  import Request from './Request'

  export default {
    components: {
      Request,
    },
  }
</script>
